export var GUIDBOOKS_ROUTES = {
    materials: {
        id: 'materials-page-id',
        route: 'materials',
    },
    constructions: {
        id: 'constructions-page-id',
        route: 'constructions',
    },
    requirements: {
        id: 'requirements-page-id',
        route: 'requirements',
    },
    issuers: {
        id: 'issuers-page-id',
        route: 'issuers',
    },
};
